import Vue from 'vue';
import Vuex from 'vuex';
import sanitizeHTML from 'sanitize-html';
import v1ItineraryList from './v1ItineraryList.vue';
import _store from './store';
import Season from '../lib/Season';

Vue.use(Vuex);
Vue.prototype.$sanitize = sanitizeHTML;

const store = new Vuex.Store(_store);

export default function app() {
  const element = document.getElementById('v1Itinerary');

  if (!element) return;

  const isKansaiByRailTargetPage = Season.isKansaiByRailTargetPath();
  if (isKansaiByRailTargetPage) {
    const contentRootElement = document.querySelector('.v1-itinerary');
    contentRootElement.classList.add('-hasTopPage');
  }

  const vm = new Vue({
    store,
    components: {
      v1ItineraryList,
    },
  });

  vm.$mount('#v1Itinerary');
}
